<script setup lang="ts">
import { useI18n, useHead, useSeoMeta } from '#imports'
import type { PropType } from '#imports'
import { clearError } from '#app/composables/error'
import type { NuxtError } from '#app'

const { $ts } = useI18n()

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true,
  },
})

const title = props.error?.statusCode === 404 ? 'Page not found' : 'Error'

useSeoMeta({
  title,
  description: props.error?.message,
})

useHead({
  htmlAttrs: {
    lang: 'en',
  },
})

const handleError = () => clearError({ redirect: '/' })

function reloadPage() {
  globalThis.location.reload()
}
</script>

<template>
  <div class="grid h-screen place-content-center bg-white px-4">
    <div class="text-center">
      <h1 class="text-7xl font-black text-neutral-200">
        {{ props.error.statusCode }}
      </h1>

      <p class="text-2xl font-bold tracking-tight text-neutral-900 sm:text-4xl">
        {{ title }}
      </p>

      <p class="mt-4 text-neutral-500">
        {{ props.error?.message }}
      </p>

      <p class="mt-4">
        {{ $ts('developersAlerted') }}
      </p>

      <div
        class="mt-6 flex items-center space-x-2"
      >
        <Button
          @click="handleError"
        >
          {{ $ts('goBackHome') }}
        </Button>

        <Button
          icon="i-heroicons-arrow-path"
          variant="ghost"
          @click="reloadPage"
        >
          {{ $ts('reloadAndTryAgain') }}
        </Button>
      </div>

      <div class="mt-6">
        <Anchor
          leadingIcon="i-heroicons-question-mark-circle"
        >
          {{ $ts('getMoreHelp') }}
        </Anchor>
      </div>
    </div>
  </div>
</template>
